import { ReactNode } from 'react';

import { Flex, Text } from '@spotify-internal/encore-web';

import styles from './SummarySection.module.css';

interface SummarySectionProps {
  title: string;
  children: ReactNode;
}

export const SummarySection = ({ title, children }: SummarySectionProps) => (
  <Flex className={styles.section} direction="column" gap="tighter">
    <Text variant="bodySmallBold" semanticColor="textSubdued">
      {title}
    </Text>
    {children}
  </Flex>
);
